import { render, staticRenderFns } from "./BtnMostrarAtualizacaoPendente.vue?vue&type=template&id=f2ef5d70&"
import script from "./BtnMostrarAtualizacaoPendente.vue?vue&type=script&lang=js&"
export * from "./BtnMostrarAtualizacaoPendente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports